export const FinanceRoutes = {
    'dashboard': '/',
    'issueCashdrawer': '/finance/cashdrawer/issue',
    'thirdpartyCashDrawer': 'finance/cashdrawer/thirdparty',
    'checkout': '/finance/checkout',
    'checkoutReceipt': '/finance/checkout/receipt',
    'balance': '/finance/cashdrawer/balance',
    'balanceReceipt': '/finance/cashdrawer/balance/receipt',
    'endofday': '/finance/endofday',
    'endofDayBalanceCashDrawer': '/finance/endofday/balance/cashdrawer',
    'vaultBalance': '/finance/vault/balance',
    'deposit': '/finance/deposit',
    'depositeUpdate': '/finance/deposit/update',
    'depositSummary': '/finance/deposit/depositId/summary',
    'depositDetail': '/finance/deposit/detail',
    'receiptManagement': '/finance/receipts/receiptId/manage',
    'receiptPayments': '/finance/receipt/payments',
    'pickup': '/finance/cashdrawer/pickup',
    'pickupReceipt': '/finance/cashdrawer/pickup/receipt',
    'pickups': '/finance/cashDrawer/pickup/confirmation',
    'distributionProductManage': '/finance/distribution/product',
    'distributionManage': '/finance/distribution',
    'distributionSearch': '/finance/distribution/search',
    'thirdPartyEndOfDay': '/finance/endofday/thirdparty',
    'generalLedgerManage': '/finance/generalledger',
    'journalEntryManage': '/finance/journalentry',
    'journalEntryTemplateSearch': '/finance/journalentry/template/search',
    'journalEntryTemplateManage': '/finance/journalentry/template',
    'depositSearch': '/finance/deposit/search',
    'reconciliation': '/finance/reconciliation',
    'reconciliationReversal': '/finance/reconciliation/reversal',
    'prePaidVoucher': 'finance/paymentVoucher/verification',
    'bankStatementManage': '/finance/bank/statement',
    'fundCustomerAccount': 'finance/fundCustomerAccount',
    'disbursement': 'finance/disbursement/manage',
    'ppvSearch': '/finance/paymentvoucher/inquiry',
    'ppvDetail': '/finance/paymentvoucher/inquiry/detail',
    'hurfBreakdown': '/finance/hurf/breakdown',
    'hurfPeriod': '/finance/hurf/period',
    'hurfCalculation': '/finance/hurf/calculation'
};
